const purchase = (state = { isProcessing: false }, action) => {
  switch (action.type) {
    case 'SET_GOALCARD_PAYLOAD':
      return {
        ...state,
        goalcardPayload: action.payload,
        isProcessing: false,
      };
    case 'CREATE_GOALCARD':
      return {
        ...state,
        isProcessing: true,
      };
    case 'CREATE_GOALCARD_SUCCESS':
      return {
        ...state,
        isProcessing: true,
        purchasedGoalcard: action.purchasedGoalcard,
      };
    case 'CREATE_GOALCARD_FAIL':
      return {
        ...state,
        isProcessing: false,
        responseCode: action.responseCode,
      };
    default:
      return state;
  }
};

export default purchase;
